export const getCheckoutRequestId = (cart, context) => {
  const fingerprint = JSON.stringify({
    items: cart
      .map(({ productId, variantId, quantity }) => ({ productId, variantId, quantity }))
      .sort((a, b) => `${a.productId}:${a.variantId}`.localeCompare(`${b.productId}:${b.variantId}`)),
    context,
  });
  let requestId = sessionStorage.getItem("store_checkout_request_id");
  const storedFingerprint = sessionStorage.getItem("store_checkout_fingerprint");
  if (!requestId || (storedFingerprint && storedFingerprint !== fingerprint)) {
    requestId = window.crypto?.randomUUID?.()
      || `${Date.now()}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;
    sessionStorage.setItem("store_checkout_request_id", requestId);
  }
  sessionStorage.setItem("store_checkout_fingerprint", fingerprint);
  return requestId;
};

export const clearCheckoutRequestId = () => {
  sessionStorage.removeItem("store_checkout_request_id");
  sessionStorage.removeItem("store_checkout_fingerprint");
};
